<template>
<div class="step-three">
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm">
    <el-form-item :label='item.dataName' :prop="item.must === 1?'must':'notmust'" v-for="(item,index) in UploadArr" :key="index">
      <div style="border:1px solid red;width:128px;height:128px;position: relative;border: 1px dashed #d9d9d9;border-radius: 6px;" v-loading="item.uploadLoading" element-loading-text="加载中"  >
        <i class="pdelete el-icon-delete" v-if="item.imgUrl" @click="removeImg(index)"></i>
        <el-upload
          class="avatar-uploader"
          action="http://mechanism.daoba.com/manager/fileUpload"
          :show-file-list="false"
          :on-success="(value)=> handleAvatarSuccess(index, value)"
          :before-upload="()=> uploadBefore(index)"
          :on-error="()=> uploadError(index)"
          >
        <img v-if="item.imgUrl" :src="item.imgUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <p style="line-height:24px;color:#F56C6C" v-if="item.must ==1 && item.msg !=''">{{item.msg}}</p>
      </div>
    </el-form-item>
    <el-drawer
        :append-to-body="true"
        :before-close="handleClose"
        :destroy-on-close="true"
        :visible.sync="innerDrawer"
        size="30%"
        >
        <div  v-loading="payLoading" element-loading-text="加载中">
          <p style="text-align:center;height:20px;margin:5px 0">
            <!-- <img src="static/images/wx_pay.png" style="width:18px; height:18px;"/> -->
            <span style="padding: 10px 24px;text-align:center;margin-left:5px;background:url('static/images/wx_pay.png')left center no-repeat;background-size: 18px 18px;">微信扫描下方二维码，完成支付</span>
          </p >
          <div style="width:100%;height:150px;text-align:center;margin-bottom:20px;">
            <div id="qrcode" ref="qrCodeDiv" style="width:120px;height:120px;margin:30px auto"></div>
          </div>
         </div>
      </el-drawer>
    <div style="text-align: center">
      <el-button type="primary" @click="submitForm('ruleForm')">提交申请</el-button>
    </div>

  </el-form>
</div>
</template>

<script>
import { queryApplyVerifyData, memberApply, queryMemberOrderStatus } from '@/api/association'
import QRCode from 'qrcodejs2'
export default {
  name: 'StepOne',
  components: {
    QRCode
  },
  data () {
    return {
      uploadLoading: false,
      innerDrawer: false,
      payLoading: false,
      timer: null,
      // subParameter: {
      //   'associationId': 0,
      //   'idNo': '',
      //   'memberCode': '',
      //   'memberName': '',
      //   'memberType': 0,
      //   'phoneNo': '',
      //   'pwd': '',
      //   'type': 0,
      //   'typeIds': '',
      //   'verifyDatas': '',
      //   'years': 0
      // },
      errorMsg: '',
      UploadArr: [],
      needUploadData: [],
      ruleForm: {
        name: '',
        region: '',
        num: 1,
        type: []

      },
      rules: {
        must: [
          { required: true }
        ],
        notmust: [
          { required: false }
        ]
      },
      dialogVisible: false
    }
  },
  methods: {
    submitForm (formName) {
      var validResult = true
      this.UploadArr.forEach(item => {
        if (item.must === 1 && item.imgUrl === '') {
          item.msg = '请选择图片'
          validResult = false
        }
      })
      if (validResult) {
        this.memberApply()
      }
    },
    queryApplyVerifyData () {
      let memberInfo = JSON.parse(localStorage.getItem('memberInfo'))
      let parameter = {
        assoId: localStorage.getItem('assoId'),
        memberTypeId: memberInfo.typeIds
      }
      queryApplyVerifyData(parameter).then(res => {
        if (res.data.status === 0) {
          if (res.data.data) {
            this.needUploadData = res.data.data
            res.data.data.forEach(item => {
              this.UploadArr.push({ id: item.id, dataName: item.dataName, must: item.must, imgUrl: '', uploadLoading: false, msg: '' })
            })
            // this.getDisclaimerByAssoId()
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    memberApply () {
      let verifyDatas = []
      this.UploadArr.forEach(item => {
        let itemData = {
          id: item.id,
          path: item.imgUrl
        }
        verifyDatas.push(itemData)
      })
      let applyInfo = JSON.parse(localStorage.getItem('applyInfo'))
      let memberInfo = JSON.parse(localStorage.getItem('memberInfo'))
      let subParameter = {
        associationId: localStorage.getItem('assoId'),
        idNo: memberInfo.idCode,
        memberName: memberInfo.memberName,
        memberType: memberInfo.memberType,
        memberCode: '',
        phoneNo: applyInfo.phoneNo,
        pwd: applyInfo.pass,
        type: 1,
        typeIds: memberInfo.typeIds,
        verifyDatas: JSON.stringify(verifyDatas),
        years: memberInfo.year,
        memberNameLetter: memberInfo.memberNameLetter
      }
      // this.innerDrawer = true
      this.payLoading = true
      memberApply(subParameter).then(res => {
        this.payLoading = false
        if (res.data.status === 0) {
          this.innerDrawer = true
          // $('#qrcode').html('')
          this.paySure(res.data.data.orderNo)
          // this.ifPay = false
          this.$nextTick(() => {
            this.bindQRCode(res.data.data.payUrl)
          })
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch((res) => {
        this.payLoading = false
        // hideLoading()
        this.$message.warning('网络错误')
      })
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    removeImg (index) {
      this.UploadArr[index].imgUrl = ''
    },
    uploadBefore (index) {
      this.UploadArr[index].uploadLoading = true
    },
    uploadError (index) {
      this.UploadArr[index].uploadLoading = false
      this.$message.error('上传失败，请重新上传')
    },
    handleAvatarSuccess (index, file) {
      // debugger
      console.log(index, file)
      this.UploadArr[index].uploadLoading = false
      this.UploadArr[index].msg = ''
      this.UploadArr[index].imgUrl = file.qiniuUrl
    },
    // 支付
    paySure (orderNo) {
      this.timer = setInterval(() => {
        queryMemberOrderStatus(orderNo).then(res => {
          if (res.data.status === 0) {
            if (res.data.data === 1) {
              clearInterval(this.timer)
              this.$message.success('支付成功')
              this.innerDrawer = false
              localStorage.removeItem('applyInfo')
              localStorage.removeItem('memberInfo')
              this.$router.push({
                name: `Login`
              })
            }
          }
        }).catch(() => {
          clearInterval(this.timer)
          this.$message.warning('支付失败，请重新支付！')
        })
      }, 1000)
    },
    bindQRCode: function (str) {
      // eslint-disable-next-line no-new
      this.qrcode = new QRCode(this.$refs.qrCodeDiv, {
        text: str,
        width: 120,
        height: 120,
        colorDark: '#333333', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        correctLevel: QRCode.CorrectLevel.L// 容错率，L/M/H
      })
    },
    handleClose (done) {
      this.$refs.qrCodeDiv.innerHTML = ''
      this.innerDrawer = false
      clearInterval(this.timer)
      this.ifPay = true
    }
  },
  mounted () {

  },
  created () {
    this.queryApplyVerifyData()
    // this.bg1.height = this.getHeight() + 'px'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .step-three  /deep/ .el-form-item__label{
    color: #fff;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .a4Option .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 128px;
    height: 128px;
    line-height: 128px;
    text-align: center;
  }
  .avatar {
    width: 128px;
    height: 128px;
    display: block;
  }
  .pdelete {
    position: absolute;
    width:24px;
    height: 24px;
    left: 50%;
    top:50%;
    margin-left: -12px;
    margin-top: -12px;
    z-index: 1;
    color: #fff;
    cursor: pointer;
  }
  .el-icon-delete:before{
    font-size: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/register/components/stepThree.vue